export default function splitCamelCase(text: string): string {
  if (text && typeof text === 'string') {
    return text.split(/(?=[A-Z])/).join(' ')
  }

  return ''
}
